import React from 'react';
import {Menu, Layout, Icon} from 'antd';
import {Link} from 'react-router-dom';
const {Sider} = Layout;

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false
        }
    }

    render() {
        const {auth: {isAuthenticated}, selectedMenu} = this.props;
        if (!isAuthenticated) {
            return <div />;
        }
        const menuItems = [
            {key: '/admin/users', label: 'Admin Users', icon: 'team'},
            {key: '/admin/applications', label: 'New Applications', icon: 'solution'},
            {key: '/admin/landlords', label: 'Registered Landlords', icon: 'home'},
            {key: '/admin/accounts', label: 'Invoicing & Accounts', icon: 'book'}
        ];

        const current = menuItems.find(i => i.key === selectedMenu);
        const selected = current && [current.key];
        const onCollapse = collapsed => {
            this.setState({
                collapsed
            })
        };
        return (
            <Sider
                id="sider"
                width={250}
                style={{ background: '#fff' }}
                collapsible
                collapsed={this.state.collapsed}
                onCollapse={onCollapse}
                breakpoint="sm"
            >
                <Menu
                    defaultSelectedKeys={selected}
                    style={{ height: '100%', paddingTop: '24px' }}
                    mode='inline'
                >
                    {menuItems.map(i => (
                        <Menu.Item key={i.key} style={{overflow: 'hidden', whiteSpace: 'normal'}}>
                            <Link to={i.key} style={{display: 'inline-block', width: '100%'}}>
                                <Icon type={i.icon} /> {i.label}
                            </Link>
                        </Menu.Item>
                    ))}
                </Menu>
            </Sider>
        );
    }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Sidebar.js